import { SearchIcon } from "@heroicons/react/solid"
import { HttpError, useOne } from "@refinedev/core";
import Button from "components/button"
import Input from "components/input"
import { Label } from "components/label";
import Select from "components/select";
import { useState } from "react";
import { STATUS_OPTIONS } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {

  const { data, isFetching } = useOne<any[], HttpError>({
    resource: "admin-account/role/all/ids?include_inactive=true",
    id: "",
    meta: {
      resource: "data"
    }
  });

  const roleIds = (data?.data ?? []).map((role: any) => (
    { value: role.id, label: role.name }
  ));
  
  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "role_id", operator: "eq", value: role},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [isActive, setIsActive] = useState(currentFilterValues.is_active);
  const [role, setRole] = useState(currentFilterValues.role_id);

  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1">
        <Label id="q" name="Search" />
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            id='q'
            type="text"
            placeholder="Search by Full name, Email"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1">
        <Label id="role_id" name="Role name" />
        <div className="mt-2">
          <Select
            options={roleIds}
            isLoading={isFetching}
            isClearable={true}
            id="is_active"
            placeholder="Select role"
            className="py-0.5"
            value={roleIds.find((d) => d.value === role)}
            onChange={(selected: {label: string; value: string}) => setRole(selected?.value)}
          />
        </div>
      </div>
      <div className="flex-1">
        <Label id="is_active" name="Status" />
        <div className="mt-2">
          <Select
            options={STATUS_OPTIONS}
            isClearable={true}
            id="is_active"
            placeholder="Select Status"
            className="py-0.5"
            value={STATUS_OPTIONS.find((d) => d.value === isActive)}
            onChange={(selected: {label: string; value: string}) => setIsActive(selected?.value)}
          />
        </div>
      </div>
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full bg-white rounded-md px-3 text-brand-500 py-2 border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}